export const GET_ALL_BANNERS = "GET_ALL_BANNERS";
export const ADD_NEW_BANNER = "ADD_NEW_BANNER";
